import React from 'react';

// Golden Question icon - elegant gold square with question mark
export const GoldenQuestionIcon = ({ size = 28, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      className={className}
    >
      {/* Gradient definitions */}
      <defs>
        <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f5d67b" />
          <stop offset="30%" stopColor="#d4a84b" />
          <stop offset="70%" stopColor="#c9952a" />
          <stop offset="100%" stopColor="#a67c00" />
        </linearGradient>
        <linearGradient id="goldGradientLight" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffeeb8" />
          <stop offset="100%" stopColor="#d4a84b" />
        </linearGradient>
        <linearGradient id="questionGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#c9952a" />
          <stop offset="100%" stopColor="#8b6914" />
        </linearGradient>
      </defs>
      
      {/* Outer gold rounded square with shadow effect */}
      <rect 
        x="2" 
        y="2" 
        width="28" 
        height="28" 
        rx="6" 
        fill="url(#goldGradient)"
      />
      
      {/* Inner highlight */}
      <rect 
        x="3" 
        y="3" 
        width="26" 
        height="13" 
        rx="5" 
        fill="url(#goldGradientLight)"
        opacity="0.3"
      />
      
      {/* White circle in center */}
      <circle 
        cx="16" 
        cy="16" 
        r="9" 
        fill="white"
      />
      
      {/* Question mark */}
      <text 
        x="16" 
        y="20" 
        textAnchor="middle" 
        fontSize="14" 
        fontWeight="bold"
        fontFamily="Georgia, serif"
        fill="url(#questionGradient)"
      >
        ?
      </text>
    </svg>
  );
};

export default GoldenQuestionIcon;
